import { Tooltip } from 'recharts';

type Props = {
  formatter: (value: string) => [string, string];
};

export function CustomTooltip({ formatter }: Props) {
  return (
    <Tooltip
      formatter={formatter}
      contentStyle={{
        backgroundColor: '#fff',
        borderRadius: '4px',
        border: '1px solid #ccc',
      }}
      separator=": "
      itemStyle={{ color: '#333', opacity: 0.5 }}
      labelStyle={{ fontWeight: 'bold', color: '#333' }}
    />
  );
}
